// // import * as ol from 'openlayers/dist/ol-debug';
// import * as ol from 'openlayers/dist/ol.js';
// // import * as ol from 'openlayers';

import proj4 from 'proj4';
//// <reference path = '../../ol3-layerswitcher.d.ts' />
import * as $ from 'jquery/dist/jquery';
import * as _ from 'lodash/lodash';
import * as jstsIo from 'jsts/org/locationtech/jts/io';
import * as jstsOverlay from 'jsts/org/locationtech/jts/operation/overlay';
import * as JSONH from 'jsonh/js/jsonh';

import { defaults as defaultControls, Control } from 'ol/control';
import { getWidth as extGetWidth, getTopLeft as extGetTopLeft, extend as extExtend } from 'ol/extent';
import FullScreen from 'ol/control/FullScreen';
import Feature from 'ol/Feature';
// import GeometryLayout from 'ol/geom/GeometryLayout';
import MultiLineString from 'ol/geom/MultiLineString';
import Point from 'ol/geom/Point';
import Polygon from 'ol/geom/Polygon';
import { Pointer as PointerInteraction } from 'ol/interaction';
import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';
import Overlay from 'ol/Overlay';
import { get as getProjection, transform as projTransform } from 'ol/proj';
import Projection from 'ol/proj/Projection';
import { register } from 'ol/proj/proj4';
import olMap from 'ol/Map';
import { Fill, RegularShape, Stroke, Style, Icon } from 'ol/style';
import { StyleLike } from 'ol/style/Style';
import OSM from 'ol/source/OSM';
import TileArcGISRest from 'ol/source/TileArcGISRest';
import XYZ from 'ol/source/XYZ';
import VectorSource from 'ol/source/Vector';
import WMTS from 'ol/source/WMTS';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import View from 'ol/View';
import Select from 'ol/interaction/Select';
import Modify from 'ol/interaction/Modify';
import Snap from 'ol/interaction/Snap';

import LayerSwitcher from 'ol-layerswitcher';

export namespace LRSMap {

	export type BaseMapType = 'Open Street Map' | 'ArcGIS Cache' | 'WMTS';

	export class BaseMap {
		public type: BaseMapType;
		public description: string; /// 'hillshade'
		public url: string;
		public name: string;
		public initialExtent: number[];
		public visible = true;
		constructor(type: BaseMapType, name: string, visible: boolean, description?: string, url?: string, initialExtent?, layerInfo?) {
			this.type = type;
			this.description = description;
			this.url = url;
			this.name = name;
			this.visible = visible;
			this.initialExtent = initialExtent;
		}
	}

	/** Current Event On Map **/
	export class EventLayer {
		private name = ''; // has to be featureClassName.
		private eventData; // raw event data
		private featureIdCol;
		private fromMeasCol;
		private toMeasCol;
		private features; // features that can be added to ol layer. converted from eventData. ///??? not sure if needed
		private visible = true;
		private symbology;
		private symbologyName;
		private currentSymbology; ///???
		private olLayer;
		private featureType;
		private routeSegment;
		private vectorSource;

		public setLayerStyle: StyleLike;
		constructor(routeSegment, config?) {
			this.routeSegment = routeSegment;
			if (config) {
				this.setLayerStyle = config.setLayerStyle || this.setLayerStyleBySymbolology;
			}
			const options: any = {
				title: 'Event Layer',
				visible: this.visible,
				source: this.createVectorSource(),
				style: this.setLayerStyle
			};
			this.olLayer = new VectorLayer(options);
		}
		public createVectorSource() {
			this.vectorSource = new VectorSource({
			});
			return this.vectorSource;
		}
		public getVisible() {
			return this.visible;
		}
		public setVisible(visible: boolean) {
			this.visible = visible;
			this.olLayer.setVisible(visible);
		}
		// TODO: Remove. use getSource().getFeatures() instead
		public getFeatures() {
			return this.features;
		}
		public getEventLayer() {
			return this.olLayer;
		}
		public getName() {
			return this.name;
		}
		public getFeatureIdCol() {
			return this.featureIdCol;
		}
		public isFeatureOnLayer(id): boolean {
			const feature = this.olLayer.getSource().getFeatureById(id);
			return !!feature;
		}

		/* Update features and names of the layer
		 * draw features
		 * features is an array of ol.Feature
		 */
		public setEventFeature(featureClass, symbologySequence) {
			this.symbologyName = symbologySequence.symbologyName;
			for (const symbology of featureClass.symbologys) {
				if (this.symbologyName === symbology.name) {
					this.symbology = symbology;
					break;
				}
			}

			this.name = featureClass.name;
			this.features = featureClass.featuresClassData;
			this.featureType = featureClass.featureType;
			this.featureIdCol = featureClass.featureIDCol;
			this.fromMeasCol = featureClass.fromMeasCol;
			this.toMeasCol = featureClass.toMeasCol;
			this.clearFeature();
			if (this.featureType === 'L') {
				for (const feature of this.features) {
					if (!(feature[this.fromMeasCol] > this.routeSegment.endMP && feature[this.toMeasCol] < this.routeSegment.startMP)) {
						this.drawLine(feature[this.fromMeasCol], feature[this.toMeasCol], feature);
					}
				}
			} else {
				for (const feature of this.features) {
					if (feature[this.fromMeasCol] < this.routeSegment.endMP && feature[this.fromMeasCol] > this.routeSegment.startMP) {
						this.drawPoint(feature[this.fromMeasCol], feature);
					}
				}
			}
		}

		public searchMPLoc(lrsCoords, milePost, measDm?) {
			measDm = measDm || 2;
			if (_.findIndex(lrsCoords, element => element[measDm] === milePost) !== -1) {
				return _.find(lrsCoords, element => element[measDm] === milePost);
			} else {
				const maxIndex = _.findIndex(lrsCoords, element =>  element[measDm] > milePost);
				if (maxIndex <= 0) {
					return null;
				} else {
					const ratio = (milePost - lrsCoords[maxIndex - 1][measDm]) / (lrsCoords[maxIndex][measDm] - lrsCoords[maxIndex - 1][measDm]);
					const x = lrsCoords[maxIndex - 1][0] + ratio * (lrsCoords[maxIndex][0] - lrsCoords[maxIndex - 1][0]);
					const y = lrsCoords[maxIndex - 1][1] + ratio * (lrsCoords[maxIndex][1] - lrsCoords[maxIndex - 1][1]);
					const point = new Array(lrsCoords[0].length);
					point[0] = x;
					point[1] = y;
					point[measDm] = parseFloat(milePost);
					return point;
				}
			}

		}
		public drawPoint(milePoint, properties?) {
			let multiLines;
			if (this.routeSegment.routeGeom.geometry.type === 'LineString') {
				multiLines = [this.routeSegment.routeGeom.geometry.coordinates];
			} else {
				multiLines = this.routeSegment.routeGeom.geometry.coordinates;
			}
			const measDm = this.routeSegment.routeGeom.lrsdm - 1 || 2;
			const multiLineString = [];
			for (const line of multiLines) {
				if (this.searchMPLoc(line, milePoint, measDm) != null) {
					const pointFeature = new Feature({
						geometry : new Point([this.searchMPLoc(line, milePoint, measDm)[0], this.searchMPLoc(line, milePoint, measDm)[1]])
					});
					pointFeature.setProperties({info: properties});
					this.vectorSource.addFeature(pointFeature);
					break;
				}
			}
		}
		public drawLine(startMP, endMP, id?, properties?) {
			console.log('start drawLine');
			const multiLines = this.routeSegment.routeGeom.geometry.type === 'LineString'
				? [this.routeSegment.routeGeom.geometry.coordinates]
				: this.routeSegment.routeGeom.geometry.coordinates;
			// measure dimension of route geometry
			const measDm = this.routeSegment.routeGeom.lrsdm - 1 || 2;
			const multiLineString = [];
			for (const line of multiLines) {
				const coordinates = line.filter( element => {
					// console.log('measure: ' + element[measDm]);
					// console.log(element[measDm] > startMP);
					// console.log(element[measDm] < endMP);
					return element[measDm] > startMP && element[measDm] < endMP;
				});
				const startMPOnRoute = this.searchMPLoc(line, startMP, measDm);
				const endMPOnRoute = this.searchMPLoc(line, endMP, measDm);
				if (startMPOnRoute != null) {
					coordinates.unshift(startMPOnRoute);
				}
				if (endMPOnRoute != null) {
					coordinates.push(endMPOnRoute);
				}
				const routePoints = [];
				for (const coordinate of coordinates) {
					routePoints.push([coordinate[0], coordinate[1]]);
				}
				if (routePoints.length >= 2) {
					multiLineString.push(routePoints);
				}
			}
			const lineFeature = new Feature({
				geometry : new MultiLineString(multiLineString)
			});
			// Set feature id
			if (id) {
				lineFeature.setId(id);
			}
				// Set feature style // Don't do this since it will override highilight style
					// if (style) {
					// 	lineFeature.setStyle(style);
					// }
			if (properties) {
				lineFeature.setProperties({info: properties});
			}
			this.vectorSource.addFeature(lineFeature);
			console.log('end drawLine');
		}
		public clearFeature() {
			this.vectorSource.clear();
		}


		public draw(features, name) {
			this.features = features;
			this.name = name;
			this.olLayer.clear();
			this.olLayer.getSource().addFeatures(features);
		}

		/* ------------------ TODO ------------------- */
		public getFeatureFromEventData() {
		}
		public setLayerStyleBySymbolology(feature): StyleLike {
			let fillColor = 'rgb(255, 255, 255)'; // -----set default color avoide crash
			let lineWidth, shape, rotate, size;
			const symbols = this.symbology.symbologyData;
			if (this.symbology.symbolType === 'NOMINAL') {
				for (const symbol of symbols) { // -----loop for others symbol and set default
					if (symbol.value === 'Others') {
						fillColor = symbol.color;
						lineWidth = symbol.lineWide;
						if (symbol.pointShape === 1) {
							shape = 20; // TODO fix to circle
							size = symbol.pointRadius;
						} else {
							shape = symbol.pointShape;
							rotate = ((shape === 4) ? (Math.PI / 4) : 0);
							size = symbol.pointRadius;
						}
						break;
					} else if (feature.get(this.symbologyName) === symbol.value) {
						fillColor = symbol.color;
						lineWidth = symbol.lineWide;
						if (symbol.pointShape === 1) {
							shape = 20; // TODO fix to circle
							size = symbol.pointRadius;
						} else {
							shape = symbol.pointShape;
							rotate = ((shape === 4) ? (Math.PI / 4) : 0);
							size = symbol.pointRadius;
						}
					}
				}
			} else if (this.symbology.symbolType === 'INTERVAL' || this.symbology.symbolType === 'ORDINAL') {
				for (const symbol of symbols) {
					const symbolValue = symbol.value.split(':'); // -----split(str to array) symbol range eg: '[61:70]' --> ['[61', '70]']
					const minBoundValue = parseFloat(symbolValue[0].replace(/^\D+/g, '')); // -----use regex get number from string
					const maxBoundValue = parseFloat(symbolValue[1].replace(/\D+$/g, ''));
					const startSymbol = symbolValue[0][0];
					const temp = symbolValue[1];
					const endSymbol = temp[temp.length - 1];
					const feaSyName = feature.get(this.symbologyName);
					// console.log(feaSyName);
					if (((startSymbol === '(' && feaSyName > minBoundValue) ||
							(startSymbol === '[' && feaSyName >= minBoundValue)) &&
						((endSymbol === ')' && feaSyName < maxBoundValue) ||
							(endSymbol === ']' && feaSyName <= maxBoundValue))) {
						fillColor = symbol.color;
						lineWidth = symbol.lineWide;
						if (symbol.pointShape === 1) {
							shape = 20; // need fix to circle
							size = symbol.pointRadius;
						} else {
							shape = symbol.pointShape;
							rotate = ((shape === 4) ? (Math.PI / 4) : 0);
							size = symbol.pointRadius;
						}
					}
				}
			}
			const styles = [];
			const geometry_type = feature.getGeometry().getType();
			// console.log(geometry_type);
			styles['Point'] = [
				new Style({
					image: new RegularShape({
						fill: new Fill({
							color: fillColor
						}),
						points: shape,
						radius: size * 2,
						// rotation: rotate,
					})
				})
			];
			styles['LineString'] = [
				new Style({
					stroke: new Stroke({
						color: fillColor,
						width: lineWidth,
						lineJoin: 'round',
						lineCap: 'round',
						// lineDash: [6],
					})
				})
			];
			if (geometry_type === 'Point') {
				feature.setProperties({
					featureStyle: {
						geomType: 'Point',
						fillColor: fillColor,
						points: shape,
						radius: size * 2,
						rotation: rotate
					}
				});
			} else if (geometry_type === 'LineString') {
				feature.setProperties({
						featureStyle: {
							geomType: 'LineString',
							fillColor: fillColor,
							lineWidth: lineWidth,
							lineJoin: 'round',
							lineCap: 'round',
					}
				});
			}
			return styles[geometry_type];
		}

		///??? getOlLayer needs further discussion. since the actual layer's visibility/features/... can be changed through it.
		public getOlLayer() {
			return this.olLayer;
		}
		/* ------------------------------------------- */

	}
	export class RouteLayer {

		private olLayer;
		private vectorSource;
		private cursorLayer;
		// Cursor geom
		private cursorGeom;
		private routeSegment;
		// private milePoint;

		constructor(RouteSegment) {
			this.routeSegment = RouteSegment;
			this.olLayer = new VectorLayer({
				visible: true,
				source: this.createVectorSource(),
				style: new Style({
					stroke: new Stroke({
						color: 'rgba(198, 198, 198, 0.8)', // 'rgba(204, 242, 38, 0.8)', // 'rgba(220,220,220, 0.9)', // '#283f75',
						width: 18,
						lineJoin: 'round',
						lineCap: 'round'
						// lineDash: [6],
					})
				})

			});
		}
		public getRouteLayer() {
			return this.olLayer;
		}
		public getCursorLayer() {
			return this.cursorLayer;
		}
		public getRouteSegment() {
			return this.routeSegment;
		}
		public getRouteExtent() {
			return this.vectorSource.getExtent();
		}
		public createVectorSource(): VectorSource {
			const vectorSource = new VectorSource({
			});
			this.vectorSource = vectorSource;
			this.updateFeature();
			return vectorSource;
		}
		public searchMPLoc(lrsCoords, milePost) {
			const measDm = this.routeSegment.routeGeom.lrsdm - 1 || 2;
			if (_.findIndex(lrsCoords, element => element[measDm] === milePost) !== -1) {
				return _.find(lrsCoords, element => element[measDm] === milePost);
			} else {
				const maxIndex = _.findIndex(lrsCoords, element => element[measDm] > milePost);
				if (maxIndex <= 0) {
					return null;
				} else {
					const ratio = (milePost - lrsCoords[maxIndex - 1][measDm]) / (lrsCoords[maxIndex][measDm] - lrsCoords[maxIndex - 1][measDm]);
					const x = lrsCoords[maxIndex - 1][0] + ratio * (lrsCoords[maxIndex][0] - lrsCoords[maxIndex - 1][0]);
					const y = lrsCoords[maxIndex - 1][1] + ratio * (lrsCoords[maxIndex][1] - lrsCoords[maxIndex - 1][1]);
					return [x, y, parseFloat(milePost)];
				}
			}

		}
		public updateFeature() {
			this.clearFeature();
			if (!this.routeSegment.routeGeom) {
				console.log('no routeGeom exist!');
				return;
			}
			const multiLines = this.routeSegment.routeGeom.geometry.type === 'LineString'
					? [this.routeSegment.routeGeom.geometry.coordinates]
					: this.routeSegment.routeGeom.geometry.coordinates;
			// measure dimension
			const measDm = this.routeSegment.routeGeom.lrsdm - 1 || 2;
			const multiLineString = [];
			for (const line of multiLines) {
				const coordinates = line.filter((element) => {
					let isWithinStart = true;
					let isWithinEnd = true;
					if (this.routeSegment.startMP || this.routeSegment.startMP === 0) {
						isWithinStart = element[measDm] > this.routeSegment.startMP;
					}
					if (this.routeSegment.endMP || this.routeSegment.endMP === 0) {
						isWithinEnd = element[measDm] < this.routeSegment.endMP;
					}
					return  isWithinStart && isWithinEnd;
				});
				if (this.searchMPLoc(line, this.routeSegment.startMP) != null) {
					coordinates.unshift(this.searchMPLoc(line, this.routeSegment.startMP));
				}
				if (this.searchMPLoc(line, this.routeSegment.endMP) != null) {
					coordinates.push(this.searchMPLoc(line, this.routeSegment.endMP));
				}
				const routePoints = [];
				for (const coordinate of coordinates) {
					routePoints.push([coordinate[0], coordinate[1]]);
				}
				if (routePoints.length >= 2) {
					multiLineString.push(routePoints);
				}
			}
			const lineFeature = new Feature({
				geometry : new MultiLineString(multiLineString)
			});
			lineFeature.setProperties({name: 'routeLayer'}, true);
			this.vectorSource.addFeature(lineFeature);
			return this.vectorSource;
		}


		public clearFeature() {
			this.vectorSource.clear();
		}

		public setCursorLayer(cursorIconUrl?) {
			this.cursorLayer = new VectorLayer({
				visible: true,
				source: new VectorSource({
					features: [new Feature({
					})]
				})
			});
			if (cursorIconUrl) {
				this.cursorLayer.setStyle(new Style({
					image: new Icon({
						src: cursorIconUrl  // '../styles/css/images/' +
					})
				}));
			}
		}

		public setCursorLoc = function(milePost) {
			const multiLines = this.routeSegment.routeGeom.geometry.type === 'LineString'
					? [this.routeSegment.routeGeom.geometry.coordinates]
					: this.routeSegment.routeGeom.geometry.coordinates;
			for (const line of multiLines) {
				if (this.searchMPLoc(line, milePost) != null) {
					this.cursorGeom = new Point([this.searchMPLoc(line, milePost)[0], this.searchMPLoc(line, milePost)[1]]);
					break;
				}
			}
			this.cursorLayer.getSource().getFeatures()[0].setGeometry(this.cursorGeom);
		};
	}

	export class WindowView {
		private routeSegment;
		private olLayer: VectorLayer<any>;
		constructor() {
			this.olLayer = new VectorLayer({
				visible: true,
				source: new VectorSource({
				})
			});
		}
		public setRouteLayer(RouteSegment) {
			this.routeSegment = RouteSegment;
		}
		public setVisibility(boolean) {
			this.olLayer.setVisible(boolean);
		}

		public getBoxLayer() {
			return this.olLayer;
		}

		public setBoxLayer(polygon) {
			const box = new Feature(
				new Polygon([polygon])
			);
			box.setProperties({name: 'windowBox'}, true);
			this.olLayer.getSource().addFeature(box);
		}

		public findIntersections() {
			const parser = new jstsIo.OL3Parser();
			const geomA = parser.read(this.routeSegment.getSource().getFeatures()[0].getGeometry());
			const geomB = parser.read(this.olLayer.getSource().getFeatures()[0].getGeometry());
			const overlayOp = jstsOverlay.OverlayOp;
			const intersection: any = overlayOp.intersection(geomA, geomB); // geomA.intersection(geomB);
			let start, end;
			if (intersection.geometries !== undefined) {
				start = intersection.geometries[0].points.coordinates[0];
				end = intersection.geometries[intersection.geometries.length - 1]
						.points.coordinates[intersection.geometries[intersection.geometries.length - 1]
						.points.coordinates.length - 1];
			} else {
				start = intersection.points.coordinates[0];
				end = intersection.points.coordinates[intersection.points.coordinates.length - 1];
			}
			let s = [];
			let e = [];
			if (start === undefined ) {
				s = [null, null];
			} else {
				s = [start['x'], start['y']];
			}
			if (end === undefined ) {
				e = [null, null];
			} else {
				e = [end['x'], end['y']];
			}
			return [s, e];
		}

		public dragWindow() {
			const Drag = function() {
				PointerInteraction.call(this, {
					handleDownEvent: Drag.prototype.handleDownEvent,
					handleDragEvent: Drag.prototype.handleDragEvent,
					handleMoveEvent: Drag.prototype.handleMoveEvent,
					handleUpEvent: Drag.prototype.handleUpEvent
				});

				this.coordinate_ = null;
				this.cursor_ = {
					ur: 'ne-resize',
					dr: 'se-resize',
					ul: 'nw-resize',
					dl: 'sw-resize',
					u: 'n-resize',
					d: 's-resize',
					r: 'e-resize',
					l: 'w-resize',
					m: 'move'
				};
				this.feature_ = null;
				this.previousCursor_ = undefined;
				this.point_ = null;
				this.edge_ = null;
				this.type_ = null;
				this.trigger_ = true;
			};

			// ol.inherits(Drag, ol.interaction.Pointer);
			Drag.prototype = Object.create(PointerInteraction.prototype);
			Drag.prototype.constructor = Drag;

			Drag.prototype.handleDownEvent = function(evt) {

				const map = evt.map;

				const feature = map.forEachFeatureAtPixel(evt.pixel, function(feat) {
					if (feat.getProperties().name  ===  'windowBox') {
						return feat;
					}
				});

				if (feature) {
					this.trigger_ = false;
					this.coordinate_ = evt.coordinate;
					this.feature_ = feature;
					const geometry = this.feature_.getGeometry();
					const coor = geometry.getCoordinates();
					const extent = this.feature_.getGeometry().getExtent();
					const width = extent[2] - extent[0];
					const length = extent[3] - extent[1];
					let tolerance;
					if (width < length) {
						tolerance = width / 3;
					} else {
						tolerance = length / 3;
					}
					if (tolerance > 50) {
						tolerance = 50;
					}
					if (Math.abs(this.coordinate_[0] - coor[0][0][0]) < tolerance) {
						if (Math.abs(this.coordinate_[1] - coor[0][0][1]) < tolerance) {
							this.point_ = 'dl';
						} else if (Math.abs(this.coordinate_[1] - coor[0][1][1]) < tolerance) {
							this.point_ = 'ul';
						} else {
							this.edge_ = 'l';
						}
					} else if (Math.abs(this.coordinate_[0] - coor[0][3][0]) < tolerance) {
						if (Math.abs(this.coordinate_[1] - coor[0][0][1]) < tolerance) {
							this.point_ = 'dr';
						} else if (Math.abs(this.coordinate_[1] - coor[0][1][1]) < tolerance) {
							this.point_ = 'ur';
						} else {
							this.edge_ = 'r';
						}
					} else {
						if (Math.abs(this.coordinate_[1] - coor[0][0][1]) < tolerance) {
							this.edge_ = 'd';
						} else if (Math.abs(this.coordinate_[1] - coor[0][1][1]) < tolerance) {
							this.edge_ = 'u';
						} else {
							this.type_ = 'm';
						}
					}
				}
				return !!feature;
			};


			Drag.prototype.handleDragEvent = function(evt) {
				const view = evt.map.getView();
				const geometry = this.feature_.getGeometry();
				let coor = geometry.getCoordinates();
				const extent = view.calculateExtent(evt.map.getSize());
				const center = view.getCenter();
				const buffer = 30;
				if (this.type_ == null) {
					if (this.point_ != null) {
						if (this.point_ === 'ur') {
							coor[0][2] = evt.coordinate;
							coor[0][3][0] = evt.coordinate[0];
							coor[0][1][1] = evt.coordinate[1];
							coor[0][4] = coor[0][0];
							if (coor[0][3][0] - buffer < extent[0]) {
								center[0] = center[0] - Math.abs(extent[0] - coor[0][3][0] + buffer);
							}
							if (coor[0][3][0] + buffer > extent[2]) {
								center[0] = center[0] + Math.abs(coor[0][3][0] - extent[2] + buffer);
							}
							if (coor[0][1][1] - buffer < extent[1]) {
								center[1] = center[1] - Math.abs(extent[1] - coor[0][1][1] + buffer);
							}
							if (coor[0][1][1] + buffer > extent[3]) {
								center[1] = center[1] + Math.abs(coor[0][1][1] - extent[3] + buffer);
							}

						}
						if (this.point_ === 'dr') {
							coor[0][3] = evt.coordinate;
							coor[0][2][0] = evt.coordinate[0];
							coor[0][0][1] = evt.coordinate[1];
							coor[0][4] = coor[0][0];
							if (coor[0][3][0] + buffer > extent[2]) {
								center[0] = center[0] + Math.abs(coor[0][3][0] - extent[2] + buffer);
							}
							if (coor[0][3][0] - buffer < extent[0]) {
								center[0] = center[0] - Math.abs(extent[0] - coor[0][3][0] + buffer);
							}
							if (coor[0][0][1] - buffer < extent[1]) {
								center[1] = center[1] - Math.abs(extent[1] - coor[0][0][1] + buffer);
							}
							if (coor[0][0][1] + buffer > extent[3]) {
								center[1] = center[1] + Math.abs(coor[0][0][1] - extent[3] + buffer);
							}
						}
						if (this.point_ === 'dl') {
							coor[0][0] = evt.coordinate;
							coor[0][1][0] = evt.coordinate[0];
							coor[0][3][1] = evt.coordinate[1];
							coor[0][4] = coor[0][0];
							if (coor[0][0][0] - buffer < extent[0]) {
								center[0] = center[0] - Math.abs(extent[0] - coor[0][0][0] + buffer);
							}
							if (coor[0][0][0] + buffer > extent[2]) {
								center[0] = center[0] + Math.abs(coor[0][0][0] - extent[2] + buffer);
							}
							if (coor[0][0][1] - buffer < extent[1]) {
								center[1] = center[1] - Math.abs(extent[1] - coor[0][0][1] + buffer);
							}
							if (coor[0][0][1] + buffer > extent[3]) {
								center[1] = center[1] + Math.abs(coor[0][0][1] - extent[3] + buffer);
							}
						}
						if (this.point_ === 'ul') {
							coor[0][1] = evt.coordinate;
							coor[0][0][0] = evt.coordinate[0];
							coor[0][2][1] = evt.coordinate[1];
							coor[0][4] = coor[0][0];
							if (coor[0][0][0] - buffer < extent[0]) {
								center[0] = center[0] - Math.abs(extent[0] - coor[0][0][0] + buffer);
							}
							if (coor[0][0][0] + buffer > extent[2]) {
								center[0] = center[0] + Math.abs(coor[0][0][0] - extent[2] + buffer);
							}
							if (coor[0][1][1] - buffer < extent[1]) {
								center[1] = center[1] - Math.abs(extent[1] - coor[0][1][1] + buffer);
							}
							if (coor[0][1][1] + buffer > extent[3]) {
								center[1] = center[1] + Math.abs(coor[0][1][1] - extent[3] + buffer);
							}
						}
					} else if (this.edge_ != null) {
						if (this.edge_ === 'r') {
							coor[0][2][0] = evt.coordinate[0];
							coor[0][3][0] = evt.coordinate[0];
							coor[0][4] = coor[0][0];
							if (coor[0][3][0] - buffer < extent[0]) {
								center[0] = center[0] - Math.abs(extent[0] - coor[0][3][0] + buffer);
							}
							if (coor[0][3][0] + buffer > extent[2]) {
								center[0] = center[0] + Math.abs(coor[0][3][0] - extent[2] + buffer);
							}
						}
						if (this.edge_ === 'l') {
							coor[0][1][0] = evt.coordinate[0];
							coor[0][0][0] = evt.coordinate[0];
							coor[0][4] = coor[0][0];
							if (coor[0][0][0] - buffer < extent[0]) {
								center[0] = center[0] - Math.abs(extent[0] - coor[0][0][0] + buffer);
							}
							if (coor[0][0][0] + buffer > extent[2]) {
								center[0] = center[0] + Math.abs(coor[0][0][0] - extent[2] + buffer);
							}
						}
						if (this.edge_ === 'u') {
							coor[0][1][1] = evt.coordinate[1];
							coor[0][2][1] = evt.coordinate[1];
							coor[0][4] = coor[0][0];
							if (coor[0][1][1] - buffer < extent[1]) {
								center[1] = center[1] - Math.abs(extent[1] - coor[0][1][1] + buffer);
							}
							if (coor[0][1][1] + buffer > extent[3]) {
								center[1] = center[1] + Math.abs(coor[0][1][1] - extent[3] + buffer);
							}
						}
						if (this.edge_ === 'd') {
							coor[0][0][1] = evt.coordinate[1];
							coor[0][3][1] = evt.coordinate[1];
							coor[0][4] = coor[0][0];
							if (coor[0][0][1] - buffer < extent[1]) {
								center[1] = center[1] - Math.abs(extent[1] - coor[0][0][1] + buffer);
							}
							if (coor[0][0][1] + buffer > extent[3]) {
								center[1] = center[1] + Math.abs(coor[0][0][1] - extent[3] + buffer);
							}
						}
					}
					geometry.setCoordinates(coor, 'XY');
				} else if (this.type_ === 'm') {
					const deltaX = evt.coordinate[0] - this.coordinate_[0];
					const deltaY = evt.coordinate[1] - this.coordinate_[1];
					geometry.translate(deltaX, deltaY);
					this.coordinate_[0] = evt.coordinate[0];
					this.coordinate_[1] = evt.coordinate[1];
					coor = geometry.getCoordinates();
					if (extent[2] - extent[0] >= coor[0][3][0] - coor[0][0][0]) {
						if (coor[0][0][0] - buffer < extent[0]) {
							center[0] = center[0] - Math.abs(extent[0] - coor[0][0][0] + buffer);
						}
						if (coor[0][0][0] + buffer > extent[2]) {
							center[0] = center[0] + Math.abs(coor[0][0][0] - extent[2] + buffer);
						}
						if (coor[0][3][0] + buffer > extent[2]) {
							center[0] = center[0] + Math.abs(coor[0][3][0] - extent[2] + buffer);
						}
						if (coor[0][3][0] - buffer < extent[0]) {
							center[0] = center[0] - Math.abs(extent[0] - coor[0][3][0] + buffer);
						}
					}
					if (extent[3] - extent[1] >= coor[0][1][1] - coor[0][0][1]) {
						if (coor[0][1][1] - buffer < extent[1]) {
							center[1] = center[1] - Math.abs(extent[1] - coor[0][1][1] + buffer);
						}
						if (coor[0][1][1] + buffer > extent[3]) {
							center[1] = center[1] + Math.abs(coor[0][1][1] - extent[3] + buffer);
						}
						if (coor[0][0][1] - buffer < extent[1]) {
							center[1] = center[1] - Math.abs(extent[1] - coor[0][0][1] + buffer);
						}
						if (coor[0][0][1] + buffer > extent[3]) {
							center[1] = center[1] + Math.abs(coor[0][0][1] - extent[3] + buffer);
						}
					}
				}
				view.setCenter(center);
			};


			Drag.prototype.handleMoveEvent = function(evt) {
				if (this.trigger_) {
					let identifier;
					const map = evt.map;
					const element = evt.map.getTargetElement();
					const feature = map.forEachFeatureAtPixel(evt.pixel, function(feat) {
						if (feat.getProperties().name  ===  'windowBox') {
							return feat;
						}
					});

					if (feature) {
						const extent = feature.getGeometry().getExtent();
						const width = extent[2] - extent[0];
						const length = extent[3] - extent[1];
						let tolerance;
						if (width < length) {
							tolerance = width / 3;
						} else {
							tolerance = length / 3;
						}
						if (tolerance > 50) {
							tolerance = 50;
						}
						if (evt.coordinate[0] - extent[0] < tolerance) {
							if (evt.coordinate[1] - extent[1] < tolerance) {
								identifier = 'dl';
							} else if (extent[3] - evt.coordinate[1] < tolerance) {
								identifier = 'ul';
							} else {
								identifier = 'l';
							}
						} else if (extent[2] - evt.coordinate[0] < tolerance) {
							if (evt.coordinate[1] - extent[1] < tolerance) {
								identifier = 'dr';
							} else if (extent[3] - evt.coordinate[1] < tolerance) {
								identifier = 'ur';
							} else {
								identifier = 'r';
							}
						} else {
							if (evt.coordinate[1] - extent[1] < tolerance) {
								identifier = 'd';
							} else if (extent[3] - evt.coordinate[1] < tolerance) {
								identifier = 'u';
							} else {
								identifier = 'm';
							}
						}
						element.style.cursor = this.cursor_[identifier];
					} else {
						element.style.cursor = 'pointer';
					}
				}
			};


			Drag.prototype.handleUpEvent = function() {
				this.coordinate_ = null;
				this.feature_ = null;
				this.point_ = null;
				this.edge_ = null;
				this.type_ = null;
				this.trigger_ = true;
				return false;
			};
			return new Drag();
		}
	}

	export class Map {
		private rootUrl: string;
		private customerId: number;
		private target: string;

		public olMap: olMap; // OpenLayer 3 ol.map
		public baseMapLayerGroup;
		public eventLayer: EventLayer; // Current event layer
		public routeLayer: RouteLayer;
		// Optional
		public interactions: {
			selectSingleClick?: Select;
			modify?: Modify;
			snap?: Snap;
		} = {};
		// Layers added that are not eventLayer / routeLayer / ?? cursorlayer TODO
		public addedLayers: any = {};

		/* ------------ data reference ------------ */
		public routeSegment;
		public featureClasses;
		public lrsFeatureClassSymbologySqs;
		/* ---------------------------------------- */
		// Event callback functions
		private onMapMoveend: Function;
		private onPointermove: Function;
		// Cursor icon url
		private cursorUrl;
		private windowLayer;

		constructor(target, olMapConfig?, config?) {
			olMapConfig = olMapConfig || {};
			config = config || {};
			this.rootUrl = config.rootUrl;
			this.customerId = config.customerId;
			this.cursorUrl = config.cursorUrl;
			this.target = target;
			// Set Proj4
			register(proj4);
			this.onMapMoveend = config.onMapMoveend;
			this.onPointermove = config.onPointermove;
			// Build
			this.build(olMapConfig);
		}

		/**
		 * Convert raw information (got from service) to standard BaseMap object
		 * Return a list of BaseMap
		 */
		public dragWindow() {
			// create private variable windowLayer as an instance of WindowView
			this.windowLayer = new WindowView();
			// initialize box size and shape
			const extent = this.olMap.getView().calculateExtent(this.olMap.getSize());
			const width = extent[2] - extent[0];
			const length = extent[3] - extent[1];
			const center = [];
			center[0] = extent[0] + (width) / 2;
			center[1] = extent[1] + (length) / 2;
			this.windowLayer.setBoxLayer(
				[[center[0] - width / 6, center[1] - length / 6],
				[center[0] - width / 6, center[1] + length / 6],
				[center[0] + width / 6, center[1] + length / 6],
				[center[0] + width / 6, center[1] - length / 6],
				[center[0] - width / 6, center[1] - length / 6]]);
			// add layer to map
			this.olMap.addLayer(this.windowLayer.getBoxLayer());
			// add interaction
			const interaction = this.windowLayer.dragWindow();
			this.olMap.addInteraction(interaction);
			// set visibility of layer
			this.windowLayer.setVisibility(true);
		}

		public recenterWindow(isViewport) {
			this.removeWindow();
			this.dragWindow();
		}

		public getIntersections(routeSegment) {
			this.windowLayer.setRouteLayer(routeSegment);
			const intersections = this.windowLayer.findIntersections();
			return intersections;
		}

		public removeWindow() {
			this.olMap.removeLayer(this.windowLayer.getBoxLayer());
		}

		public moveToTop(layer) {
			this.olMap.removeLayer(layer);
			this.olMap.addLayer(layer);
		}
		public drawCursorLayer(milePost) {
			if (!this.routeLayer || !this.routeLayer.getRouteSegment().routeGeom) {
				return;
			}
			this.routeLayer.setCursorLoc(milePost);
			// Set cursor layer on top
			this.olMap.removeLayer(this.routeLayer.getCursorLayer());
			this.olMap.addLayer(this.routeLayer.getCursorLayer());
		}

		public drawEventLayer(routeSeg, featureClasses, symbologySequence) {
			if (this.eventLayer === undefined) {
				this.eventLayer = new EventLayer(routeSeg);
				this.olMap.addLayer(this.eventLayer.getEventLayer());
				this.eventLayer.setEventFeature(featureClasses, symbologySequence);
			} else {
				this.eventLayer.setEventFeature(featureClasses, symbologySequence);
			}
		}


		public drawRouteLayer(routeSegment?) {
			if (this.routeLayer === undefined) {
				this.routeLayer = new RouteLayer(routeSegment);
				this.routeLayer.setCursorLayer(this.cursorUrl);
				this.olMap.addLayer(this.routeLayer.getRouteLayer());
				this.olMap.addLayer(this.routeLayer.getCursorLayer());
			} else {
				this.routeLayer.updateFeature();
			}
			this.fitToRoute();
			////??? not sure if need to zoom to route when draw

			// this.olMap.addLayer(this.routeLayer.getCursorLayer());
			// if (this.eventLayer != undefined) {
				// this.moveToTop(this.eventLayer)
			// }
		}
		public fitToRoute() {
			const extent = this.routeLayer.getRouteExtent();
			if (this.checkExtentValid(extent)) {
				this.olMap.getView().fit(extent, {
					size: this.olMap.getSize()
				});
			}
		}
		public zoomToLayer(layer, options?: { minReso?; padding?: number[] }) {
			const extent = layer.getSource().getExtent();
			this.zoomToExtent(extent, options);
		}
		public zoomToFeature(feat: Feature, options?: { minReso?; padding?: number[] }) {
			const extent = feat.getGeometry().getExtent();
			this.zoomToExtent(extent, options);
		}
		public zoomToExtent(extent, options?: { minReso?; padding?: number[] }) {
			options = options || {};
			const padding = options.hasOwnProperty('padding') ? options.padding : [20, 60, 20, 60];
			if (this.checkExtentValid(extent)) {
				const opt: any = {
					size: this.olMap.getSize(),
					padding: padding
				};
				if (options.minReso) {
					opt.minResolution = options.minReso;
				}
				this.olMap.getView().fit(extent, opt);
			} else {
				console.log('Zoom Failed. Extent invalid.');
			}
		}
		public getFeaturesExtent(feats: Feature[]) {
			let extentTotal;
			feats.forEach(feat => {
				const extent = feat.getGeometry().getExtent();
				if (!extentTotal) {
					extentTotal = JSON.parse(JSON.stringify(extent));
				} else {
					extentTotal = extExtend(extentTotal, extent);
				}
			})
			return extentTotal;
		}
		public checkExtentValid(extent) {
			// Check exent: an array of 4 number
			if (extent && extent.length === 4) {
				// each item is number and not infinite
				const invalid = extent.find((num) => {
					return typeof(num) !== 'number' || !isFinite(num);
				});
				if (!invalid) {
					return true;
				} else {
					return false;
				}
			}
			return false;
		}
		public removeLayer(layerName: string) {
			const layer = this.addedLayers[layerName];
			if (layer) {
				this.olMap.removeLayer(layer);
				delete this.addedLayers[layerName];
			}
		}

		public highlightFeatures(ids, keepPrev?, layer?) {
			if (!this.interactions.selectSingleClick) {
				console.log('Hightlight failed! SelectSingleClick Not Exist!');
				return null;
			}
			if (!layer) {
				layer = this.eventLayer;
			}
			if (!keepPrev) {
				this.interactions.selectSingleClick.getFeatures().clear();
			}
			for (const id of ids) {
				const feature = layer.getEventLayer().getSource().getFeatureById(id);
				if (feature) {
					this.interactions.selectSingleClick.getFeatures().push(feature);
				} else {
					console.log('No feature found with id: ' + id);
				}
			}

		}
		// Add vector layer to addedLayer
		public addLayer(name, config?: {style?; minResolution?: number; maxResolution?: number; sourceFormat?; zIndex?: number}) {
			config = config || {};
			const sourceOption: any = {};
			if (config.sourceFormat) {
				sourceOption.format = config.sourceFormat;
			}
			const options: any = {
				layerName: name, // Don't use title property here. Layer with title will be shown in layerswitcher
				source: new VectorSource(sourceOption)
			};
			const layer =  new VectorLayer(options);
			// if (config) {
			if (config.style) {
				layer.setStyle(config.style);
			}
			if (config.minResolution) {
				layer.setMinResolution(config.minResolution);
			}
			if (config.maxResolution) {
				layer.setMaxResolution(config.maxResolution);
			}
			if (config.zIndex || config.zIndex === 0) {
				layer.setZIndex(config.zIndex);
			}
			// }
			this.olMap.addLayer(layer);
			this.addedLayers[name] = layer;
			return layer;
		}
		public buildBaseMapDefs(baseMapInfo, initExtent) {
			const info: any[] = baseMapInfo.server;
			const baseMapDefs: BaseMap[] = [];
			for (let i = 0; i < info.length; i++) {
				const basemap = new BaseMap(
					info[i].Type,
					info[i].Description,
					info[i].Url, info[i].Name,
					info[i].visible, initExtent,
					info[i].LayerInfo);
				baseMapDefs.push(basemap);
			}
			return baseMapDefs;
		}
		/**
		 * To build an OpenLayer layer group of BaseMaps
		 */
		public setBaseMapsLayerGroup(baseMapDefs: BaseMap[]) {
			const baseMapLayers = [];
			let mapLayer, layerType: BaseMapType, layerName: string;
			for (let i = 0; i < baseMapDefs.length; i++) {
				layerType = baseMapDefs[i].type;
				if (layerType === 'ArcGIS Cache') {
					layerName = baseMapDefs[i].name ? baseMapDefs[i].name : baseMapDefs[i].description;
					const options = {
						title: layerName,
						type: 'base',
						visible: baseMapDefs[i].visible,
						source: new XYZ({
							url: baseMapDefs[i].url + '/tile/{z}/{y}/{x}'
						}),
						// source: new TileArcGISRest({
						// 	urls: [baseMapDefs[i].url]
						// })
					};
					mapLayer = new TileLayer(options);
					baseMapLayers.push(mapLayer);
				} else if (layerType === 'Open Street Map') {
					layerName = baseMapDefs[i].name ? baseMapDefs[i].name : 'OpenStreetMap';
					const options = {
						source: new OSM(),
						title: layerName,
						visible: baseMapDefs[i].visible,
						type: 'base'
					};
					mapLayer = new TileLayer (options);
					baseMapLayers.push(mapLayer);
				}else if (layerType === 'WMTS') {
					////////////// ummmmmmmmmmmmmmmmmmmmmmmmm need re-write ///////////////////////////////
					const projection = getProjection('EPSG:3857');
					const projectionExtent = projection.getExtent();
					const size = extGetWidth(projectionExtent) / 256;
					const resolutions = new Array(14);
					const matrixIds = new Array(14);
					for (let z = 0; z < 14; ++z) {
					// generate resolutions and matrixIds arrays for this WMTS
					resolutions[z] = size / Math.pow(2, z);
					matrixIds[z] = z;
					}
					/////////////////////////////////////////////////////////////////////////////////////////
					const options = {
						source: new WMTS({
							url: baseMapDefs[i].url, // 'https://discover.agrc.utah.gov/login/path/oliver-marvin-parking-machine/wmts',
							crossOrigin: 'Anonymous',
							layer: baseMapDefs[i].description,
							matrixSet: 'EPSG:3857',
							format: 'image/png',
							projection: projection,
							tileGrid: new WMTSTileGrid({
								origin: extGetTopLeft(projectionExtent),
								resolutions: resolutions,
								matrixIds: matrixIds
							}),
							style: 'default',
							wrapX: true
						}),
						// loadTilesWhileAnimating: true,
						title: baseMapDefs[i].description,
						visible: true,
						type: 'base'
					};
					mapLayer = new TileLayer(options);
					baseMapLayers.push(mapLayer);
				}
			}
			const options = {
				title: 'Basemaps',
				layers: baseMapLayers
			};
			const baseMapLayerGroup = new LayerGroup(options);
			this.baseMapLayerGroup = baseMapLayerGroup;
			this.olMap.addLayer(baseMapLayerGroup);
		}

		public getMapInfo(rootUrl, customerID) {
			return $.ajax({
				method: 'GET',
				url: rootUrl + 'lbcore/getMapServiceInfo',
				data: {
					customerId: customerID
				},
				context: this
			});
		}
		public updateSize() {
			this.olMap.updateSize();
		}
		public getDefaultControl() {
			return defaultControls({
				attribution: false
			}).extend([
				new FullScreen({
					label: '\u2922'
				})
			]);
		}
		public getDefaultProjection() {
			return new Projection({
				code: 'EPSG:3857',
				units: 'm'
			});
		}
		public constructView(projection, center?, resolution?, enableRotation?, zoomFactor?, minResolution?) { // TODO: extent -> initExtent ?
			return new View({
				center: center ? center : [-12457799.770160306, 4964464.121828797],
				resolution: resolution ? resolution : 100,
				projection: projection,
				// extent: this.extent,
				enableRotation: enableRotation === false ? false : true, // default true
				zoomFactor: zoomFactor ? zoomFactor : 2, // 1.1, // 1.6,
				minResolution: minResolution || null
			});
		}
		public setOlMap(control, view, layers) {
			const map = new olMap({
				target: this.target,
				layers: [],
				controls: control,
				view: view
			});
			this.olMap = map;
			if (this.onMapMoveend) {
				map.on('moveend', (e) => {
					this.onMapMoveend(e);
				});
			}
			if (this.onPointermove) {
				map.on('pointermove', (e) => {
					this.onPointermove(e);
				});
			}
		}

		public setLayerSwitcher() {
			// let layerSwitcher = new ol.control.LayerSwitcher({
			// 	tipLabel: 'Legend' // Optional label for button
			// });
			// this.olMap.addControl(layerSwitcher);
		}
		public setCurrentEventLayer(features?, eventName?) {
			features = features ? features : [];
			eventName = eventName ? eventName : '';
			this.eventLayer = new EventLayer(this.routeSegment);
			this.olMap.addLayer(this.eventLayer.getEventLayer());
		}
		public build(config) {
			const control = config.control ? config.control : this.getDefaultControl();
			const projection = config.projection ? config.projection : this.getDefaultProjection();
			const view = this.constructView(projection, config.center, config.resolution, config.enableRotation, config.zoomFactor, config.viewMinResolution);
			const layers = config.layers ? config.layers : [];
			this.setOlMap(control, view, layers);
			// This is for pre-defined basemaps. Used in LBE, LBV
			if (this.rootUrl && (this.customerId || this.customerId === 0)) {
				this.getMapInfo(this.rootUrl, this.customerId).then(function(res){
					const mapInfo = res.payload.content;
					const baseMapDefs = this.buildBaseMapDefs(mapInfo.BasemapInfo, mapInfo.MapExtent);
					this.setBaseMapsLayerGroup(baseMapDefs);
					this.setLayerSwitcher(); // Has to go after olMap is populated (in setOlMap).
					// this.setCurrentEventLayer(); // Has to go after layer switcher is set since you don't want event layer to show in layerswitcher.
					this.cursor = mapInfo.Cursor;
				}.bind(this));
			}
		}
		public updateMap(features) {
			this.drawRouteLayer(features.routeSeg);
		}
		setProjDef(name, defs) {
			proj4.defs(name, defs);
		}

		// Add tooltip element
		public addTooltipElem(id) {
			const tooltipElem = document.getElementById(id);
			const overlay = new Overlay({
				element: tooltipElem,
				offset: [10, 0],
				positioning: 'bottom-left'
			});
			this.olMap.addOverlay(overlay);
			return overlay;
		}
		public displayMapTooltip(tooltip, coord, text, timeout?: number) {
			tooltip.setPosition(coord);
			const elem = tooltip.getElement();
			elem.style.display = '';
			elem.innerHTML = text;
			// Remove tooltip after 5 seconds
			timeout = timeout || 5000;
			setTimeout(() => {
				elem.style.display = 'none';
			}, timeout);
		}
	}

	// Utilities
	export class Utilities {
		public transformProjection(featureType: string, coords, fromPrj: string, toPrj: string) {
			switch (featureType.toUpperCase()) {
				case 'POINT':
					return projTransform(coords, fromPrj, toPrj);
				case 'LINESTRING':
					return coords.map((coord) => {
						return projTransform(coord, fromPrj, toPrj);
					});
				case 'MULTILINESTRING':
					return coords.map((coordsArray) => {
						return coordsArray.map((coord) => {
							return projTransform(coords, fromPrj, toPrj);
						});
					});
			}
			return coords;
		}
	}
}
